export default __webpack_public_path__ + "ulc-redeem-locales/en-US.3c7fc54a71d54bdea49e1dbf993fc882.json";